// 智能個管師發送時間：start_offset_hours 有值即為小時模式（約診開始 ± 1～23 小時），否則照舊用天數與時分。
export const isHourMode = template => template.start_offset_hours != null && template.start_offset_hours !== '';

export function offsetHoursRule(value) {
  const text = value == null ? '' : String(value).trim();
  if (text === '') return '此欄位為必填';
  if (Number(text) > 23) return '小時數不可超過 23，請改用天';
  return (/^\d+$/.test(text) && Number(text) >= 1) || '請輸入 1～23 的整數';
}

export function formatSendTiming(template) {
  const direction = template.offset_direction === 'AFTER' ? '後' : '前';
  return isHourMode(template)
    ? `看診 ${direction} ${template.start_offset_hours}小時`
    : `看診 ${direction} ${template.start_offset_days}天 ${template.send_at_time}`;
}

// 依序為看診前天、看診前小時、看診後小時、看診後天；看診前離約診越遠越前面，看診後越近越前面，同天再比時分。
function sendTimingKey(template) {
  const after = template.offset_direction === 'AFTER';
  const hour = isHourMode(template);
  const amount = Number(hour ? template.start_offset_hours : template.start_offset_days);
  return {
    rank: hour ? (after ? 2 : 1) : (after ? 3 : 0),
    amount: after ? amount : -amount,
    time: hour ? '' : String(template.send_at_time || ''),
  };
}

// number 是排序前的位置（從 1 起算），沒有標題時仍用它編號；完全相同時保持原順序。
export function sortBySendTiming(templates) {
  return templates
    .map((template, index) => ({ template, number: index + 1, key: sendTimingKey(template) }))
    .sort((a, b) => a.key.rank - b.key.rank || a.key.amount - b.key.amount
      || a.key.time.localeCompare(b.key.time) || a.number - b.number)
    .map(({ template, number }) => ({ template, number }));
}
